import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdresseModels} from 'src/app/models/adresse-models';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';

@Component({
  selector: "app-adress-eintrag",
  templateUrl: "./adress-eintrag.component.html",
  styleUrls: ["./adress-eintrag.component.scss"],
})
export class AdressEintragComponent implements OnInit {
  @Input() formGroupAdresse: UntypedFormGroup;
  private readonly currAdresse?: AdresseModels.DetailAdresseElement;
  public cardTitle = "Adresse erfassen";

  public errormsg: string = "";
  public hasError: boolean = false;
  public anreden: AdresseModels.AddressSalutation[] = [];
  public briefAnreden: AdresseModels.AddressLetterSalutation[] = [];
  public briefAnredenAbgefuellt: AdresseModels.AddressLetterSalutation[] = [];
  private vorname: string = "";
  private name: string = "";
  private zip: string = "";
  private ort: string = "";

  constructor(
    private svcAdressen: AdresseDataService,
    private swissSettings: SwissSettingsService,
    private svcMessageBox: MessageBoxService,
    public dialogRef: MatDialogRef<AdressEintragComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdresseModels.DetailAdresseElement
  ) {
    if (data) {
      this.currAdresse = this.data!;
      if (this.currAdresse.adressID) {
        // Bestehende Adresse wird erstellt
        this.cardTitle = "Adresse bearbeiten";
      } else {
        // Neue Adresse wird erstellt
      }
    }

    this.formGroupAdresse = new UntypedFormGroup({
      fldAdressAnrede: new UntypedFormControl(),
      fldAdressBriefanrede: new UntypedFormControl(),
      fldAdressName: new UntypedFormControl(),
      fldAdressVorname: new UntypedFormControl(),
      fldAdresstitel: new UntypedFormControl(),
      fldAdressZusatz: new UntypedFormControl(),
      fldAdressStrasse: new UntypedFormControl(),
      fldAdressPlz: new UntypedFormControl(),
      fldAdressOrt: new UntypedFormControl(),
      fldAdressMobile: new UntypedFormControl(),
      fldAdressTelefon: new UntypedFormControl(),
      fldAdressEmail: new UntypedFormControl(),
      fldAdressHomepage: new UntypedFormControl(),
    });
  }

  ngOnInit(): void {
    this.svcAdressen.getAnreden(false).subscribe({
      next: (res: AdresseModels.AddressSalutation[]) => {
        this.anreden = res;
      },
      error: (error: any) => console.error("Fehler beim Ermitteln der Anreden.", error),
    });

    this.svcAdressen.getBriefanreden(false).subscribe({
      next: (res: AdresseModels.AddressLetterSalutation[]) => {
        this.briefAnreden = res;
        this.genBriefanreden();
      },
      error: (error: any) => console.error("Fehler beim Ermitteln der Briefanreden.", error),
    });
  }

  async getCountry(isoCode: string): Promise<AdresseModels.Country | undefined> {
    return new Promise((resolve) => {
      this.svcAdressen.getCountries().subscribe((res) => {
        resolve(res.find((iso) => iso.isoShort == isoCode));
      });
    });
  }

  onVornameChange(event: Event) {
    this.vorname = (event.target as HTMLInputElement).value;
    this.genBriefanreden();
  }

  onNameChange(event: Event) {
    this.name = (event.target as HTMLInputElement).value;
    this.genBriefanreden();
  }

  onZIPChange(event: Event) {
    this.zip = (event.target as HTMLInputElement).value;

    if (this.zip.length >= 4) {
      this.svcAdressen.getCityByZip(this.zip).then((res) => {
        if (res) {
          this.getCountry(res.country).then((country) => {
            if (country) {
              this.currAdresse!.country = country;
            } else {
              throw 'country not found'
            }
            this.ort = res.town;

            this.formGroupAdresse.controls["fldAdressOrt"].setValue(this.ort);
          });
        } else {
          this.ort = "";
          this.formGroupAdresse.controls["fldAdressOrt"].setValue(this.ort);
        }
      });
    }
  }

  replaceAll(str: string, find: string, replace: string) {
    return str.replace(new RegExp(find, "g"), replace);
  }

  async genBriefanreden() {
    // Hier werden die originalen Briefanreden mit Platzhaltern in das anzuzeigende Array kopiert
    this.briefAnredenAbgefuellt = [];
    this.briefAnreden.forEach((val) => this.briefAnredenAbgefuellt?.push(Object.assign({}, val)));

    // Hier werden die Platzhalter im Array ersetzt (Nachname)
    if (this.briefAnredenAbgefuellt) {
      this.briefAnredenAbgefuellt.forEach((briefAnredObj, index) => {
        if (briefAnredObj) {
          if (briefAnredObj.briefanrede.includes("%2")) {
            // Name
            if (this.name) {
              briefAnredObj.briefanrede = this.replaceAll(briefAnredObj.briefanrede, "%2", this.name);
            } else {
              briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace("%2", "");
            }
            this.briefAnredenAbgefuellt[index] = briefAnredObj;
          }

          if (briefAnredObj.briefanrede.includes("%1")) {
            // Vorname
            if (this.vorname) {
              briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace("%1", this.vorname);
            } else {
              briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace("%1", "");
            }
            this.briefAnredenAbgefuellt[index] = briefAnredObj;
          }
        }
      });
    }
  }

  onAnredeChange(anrede: AdresseModels.AddressSalutation) {
    this.formGroupAdresse.controls["fldAdressAnrede"].setValue(anrede.anrede);
  }

  onBriefanredeChange(briefAnrede: AdresseModels.AddressLetterSalutation) {
    this.formGroupAdresse.controls["fldAdressBriefanrede"].setValue(briefAnrede.briefanrede);
  }

  save() {
    if (this.swissSettings.getWebConfig().debugMode) console.log("Adresse-FormValues: ", this.formGroupAdresse.value);

    try {
      if (this.formGroupAdresse.value) {
        // Vorname
        this.currAdresse!.firstName = this.formGroupAdresse.controls["fldAdressVorname"].value;
        // Nachname
        this.currAdresse!.lastName = this.formGroupAdresse.controls["fldAdressName"].value;
        // Anrede
        this.currAdresse!.letterHead = this.formGroupAdresse.controls["fldAdressAnrede"].value;
        // Briefanrede
        this.currAdresse!.salutation = this.formGroupAdresse.controls["fldAdressBriefanrede"].value;
        // Titel
        this.currAdresse!.title = this.formGroupAdresse.controls["fldAdresstitel"].value;
        // Zusatz
        this.currAdresse!.companyDescription = this.formGroupAdresse.controls["fldAdressZusatz"].value;
        // Strasse
        this.currAdresse!.street1 = this.formGroupAdresse.controls["fldAdressStrasse"].value;
        // Postleitzahl
        this.currAdresse!.zip = this.formGroupAdresse.controls["fldAdressPlz"].value;
        // Postleitzahl
        this.currAdresse!.city = this.formGroupAdresse.controls["fldAdressOrt"].value;
        // Mobile
        this.currAdresse!.phone03 = this.formGroupAdresse.controls["fldAdressMobile"].value;
        // Telefon
        this.currAdresse!.phone01 = this.formGroupAdresse.controls["fldAdressTelefon"].value;
        // E-Mail
        this.currAdresse!.email = this.formGroupAdresse.controls["fldAdressEmail"].value;
        // Homepage
        this.currAdresse!.homepage = this.formGroupAdresse.controls["fldAdressHomepage"].value;
      }
      this.svcAdressen.newAdresse(this.currAdresse!).subscribe(() => {
        this.dialogRef.close(this.currAdresse?.adressID);
      });
    } catch (ex) {
      this.hasError = true;
      this.errormsg = "Fehler bei der Speicherung der Adresse: ";
      console.error(this.errormsg, ex);
      this.svcMessageBox.showError(this.errormsg, "!! FEHLER !!");
    }
  }
}
